export class TransferPlannerRouter {
    Id: string;
    Name: string;
    TenantKey: string;
    IsActive: boolean;
    RoutingExpression: string;
    TransformExpression: string;
    Organizations: TransferPlannerRouterOrganizationConfig[];
}

export class TransferPlannerRouterOrganizationConfig {
    AtsOrganizationId: string;
    ContactsDataSourceInstanceId: string;
}
